import React, { useState } from 'react';
import { Form } from 'antd';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import { omit } from 'lodash-es';
import ModalCustom from 'components/common/ModalCustom';
import { RestInputContext } from 'components/RestInput/RestInputContext';
import { handleApiError } from 'utils/validateUtils';
import { useCentre } from '../../Show/context';
import FormNormalStyles from './styles';

const CentreModal = ({
  onCancel,
  title,
  children,
  record,
  formatOnSubmit,
  ...props
}) => {
  const [form] = Form.useForm();

  const { validateFields, resetFields } = form;

  const { updateCentre } = useCentre();

  const [loading, setLoading] = useState(false);

  const onOk = () => {
    validateFields()
      .then((values) => {
        const restValue = omit(values, [
          'urlVideo',
          'displayAddress',
          'brand',
          'company',
          'primaryChildCareService',
          'dateApplied',
          'type',
          'provider',
          'placeAllowed',
        ]);
        setLoading(true);
        updateCentre(formatOnSubmit(restValue))
          .then(({ payload }) => {
            handleApiError(payload?.data, form);
            if (payload?.data?.id) {
              handleCancel();
            }
          })
          .finally(() => setLoading(false));
      })
      .catch((error) => {
        form.scrollToField(error.errorFields?.[0]?.name?.[0]);
      });
  };

  const handleCancel = () => {
    onCancel();
    resetFields();
  };

  return (
    <ModalCustom
      title={i18next.t(title)}
      onCancel={handleCancel}
      onOk={onOk}
      loading={loading}
      {...props}
    >
      <FormNormalStyles>
        <Form form={form} layout="vertical" scrollToFirstError>
          <RestInputContext.Provider value={{ form, record }}>
            {children}
          </RestInputContext.Provider>
        </Form>
      </FormNormalStyles>
    </ModalCustom>
  );
};

CentreModal.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
  title: PropTypes.string,
  children: PropTypes.node,
  isDisabled: PropTypes.bool,
  record: PropTypes.object,
  onValuesChange: PropTypes.func,
  formatOnSubmit: PropTypes.func,
};

CentreModal.defaultProps = {
  formatOnSubmit: (value) => value,
};

export default CentreModal;
